import { Suspense } from 'react';
import { CompanyArtists } from '@features';
import { Skeleton, Stack } from '@mantine/core';

export const CompanyDetailsArtistsPage: React.FC = () => {
  return (
    <Stack py="md">
      <Suspense fallback={<Skeleton mih={120} />}>
        <CompanyArtists />
      </Suspense>
    </Stack>
  );
};
